import Vue from "vue";
import App from "./App.vue";
import { BootstrapVue } from 'bootstrap-vue'
import store from "./store";
import router from "./router";
import Chartkick from "vue-chartkick";
import { Chart } from "chart.js";
import Toasted from "vue-toasted";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import "admin-lte/plugins/jquery/jquery";
import "admin-lte/plugins/bootstrap/js/bootstrap";
import "admin-lte/build/js/AdminLTE";
import "admin-lte/dist/css/adminlte.min.css";
import jwt_decode from "jwt-decode"
import Vuelidate from 'vuelidate'
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import vueCountryRegionSelect from 'vue-country-region-select'

import interceptorsSetup from './services/InterceptorSetup'

interceptorsSetup(store)

let token = localStorage.getItem('token')
if (token != null) {
    let access_token = jwt_decode(token)
    Vue.prototype.$user_id = access_token.user_id
}

Vue.use(VueTelInput);
Vue.config.productionTip = false;
Vue.use(Chartkick.use(Chart));
Vue.use(vueCountryRegionSelect)
Vue.use(Toasted);
Vue.use(VueSweetalert2);
Vue.use(BootstrapVue)
Vue.use(Vuelidate)

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");